import React from 'react'
import styled from 'styled-components'

import { Stack, Text } from '@procsea/design-system'

import { useUser } from 'src/contexts/userContext'

const StyledStack = styled(Stack)`
  overflow-wrap: break-word;
  padding: ${props => props.theme.spacings.small};
`

const AccountContextMenuHeader = () => {
  const user = useUser()

  return (
    <StyledStack data-e2e="account-context-menu-header">
      <Text data-e2e="account-context-menu-header-username" variant="black">
        {user?.fullName}
      </Text>
      <Text data-e2e="account-context-menu-header-email" variant="foreground" size="small">
        {user?.email}
      </Text>
    </StyledStack>
  )
}

export default AccountContextMenuHeader
